import { getPath } from '@/router/common'

const baseUrl = {
  title: '互联互通',
  path: 'hlht'
}

export default [
  {
    path: getPath('DockingInformation', baseUrl),
    name: 'hlht_DockingInformation',
    component: () => import(/* webpackChunkName: "hlht_DockingInformation" */ '@/views/hlht/dockingInformation/index.vue'),
    meta: {
      title: '对接信息'
    }
  },
  {
    path: getPath('UpstreamInformation', baseUrl),
    name: 'hlht_UpstreamInformation',
    component: () => import(/* webpackChunkName: "hlht_UpstreamInformation" */ '@/views/hlht/upstreamInformation/index.vue'),
    meta: {
      title: '下游信息'
    }
  },
  {
    path: getPath('HlhlSchedule', baseUrl),
    name: 'hlht_HlhlSchedule',
    component: () => import(/* webpackChunkName: "hlht_HlhlSchedule" */ '@/views/hlht/hlhlSchedule/index.vue'),
    meta: {
      title: '互联互通计划表'
    }
  },
  {
    path: getPath('HlhtScheduleImport', baseUrl),
    name: 'hlht_HlhtScheduleImport',
    component: () => import(/* webpackChunkName: "hlht_HlhtScheduleImport" */ '@/views/hlht/hlhtScheduleImport/index.vue'),
    meta: {
      title: '导入互联互通计划表'
    }
  },
  {
    path: getPath('HlhlScheduleAddOrEdit', baseUrl),
    name: 'hlht_HlhlScheduleAddOrEdit',
    component: () => import(/* webpackChunkName: "hlht_HlhlScheduleAddOrEdit" */ '@/views/hlht/hlhlScheduleAddOrEdit/index.vue'),
    meta: {
      title: '新增修改互联互通计划表数据'
    }
  },
  {
    path: getPath('Index', baseUrl),
    name: 'hlht_Index',
    component: () => import(/* webpackChunkName: "hlht_Index" */ '@/views/hlht/index/index.vue'),
    meta: {
      title: '托运单开单'
    }
  }
]
